<template>
<div v-if="myMembership">
  <main :class="['members']">
    <section
      v-if="this.memberSearchResults && this.memberSearchResults.length > 0"
      :class="[sectionClass, 'content-area']"
    >
      <component
        v-for="member in memberSearchResults"
        :is="listedComponentType"
        :key="member.id"
        :rallyId="rallyId"
        :memberProp="member"
        :isAdmin="isAdmin"
      />
    </section>
    <section v-if="this.noSearchResultsFlag">
      <br />
      <br />
      <br />
      <br />
      <h3 class="title" style="text-align:center">No results!</h3>
    </section>

    <div
      v-if="this.myMembership && (!this.memberSearchResults || this.memberSearchResults.length === 0) &&
          !this.noSearchResultsFlag">
      <section :class="[sectionClass, 'content-area']">
        <component
          v-for="member in this.sortedMemberList(this.members)"
          :is="listedComponentType"
          :key="member.id"
          :rallyId="rallyId"
          :memberProp="member"
          :isAdmin="isAdmin"
        />
      </section>
      <div class="infinite-loading-container" > 
      <infinite-loading v-if="!isComplete" ref="infLoad" @infinite="infiniteHandler"  :slots="{ complete: ' ' }"/>
      <span ><br/> <i @click="reloadPage" class="fa fa-sync" ><div style="font-family:sans-serif;">Refresh</div></i><br/><br/><br/></span>
      </div>
    </div>

  </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { router, getChannelSlug } from "../common";
import { findDefaultChannelOfType } from "../common";
import { userInfo } from "../common/user-info";
import {eventBus} from "@/main";
export default {
  props: ["rally", "channel"],
  data() {
    return {
      isComplete:false,
      layout: {
        Directory: {
          component: "DirectoryMember",
          section: "directory"
        },
        Members: {
          component: "MembersMember",
          section: "friends"
        }
      },
    };
  },
  computed: {
    ...mapState("memberships", [
      "membersByRallyId",
      "memberSearchResults",
      "noSearchResultsFlag",
      "membersByUserIdByRallyId",
      "myMembershipByRallyId",
      "membersByUserId",
      "resultCountByRally", "membersFilter"
    ]),
    ...mapState("user", ["usersById"]),
    members() {
      return this.membersByRallyId[this.rallyId];
    },
    channelSlug() {
      return getChannelSlug(this.$route)
    },
    listedComponentType() {
      return this.layout[this.channel.attributes.type]["component"];
    },
    sectionClass() {
      return this.layout[this.channel.attributes.type]["section"];
    },
    toolbarOptions() {
      let options = new Array();
      return options;
    },
    isAdmin() {
      // TODO: Rally admin should be able to see everyone's profile.
      return this.myRole === "Admin" || this.myRole === "Owner";
    },
    myUserId() {
      // be defensive in case userInfo only has id
      const info = userInfo();
      return parseInt(info.user_id || info.id);
    },
    myMembership() {
      const rid = this.rallyId;
      const uid = this.myUserId;

      // 1) preferred: explicitly fetched membership for this rally
      if (this.myMembershipByRallyId && this.myMembershipByRallyId[rid]) {
        return this.myMembershipByRallyId[rid];
      }

      // 2) fallback: membership from per-rally user map
      if (
        this.membersByUserIdByRallyId &&
        this.membersByUserIdByRallyId[rid] &&
        this.membersByUserIdByRallyId[rid][uid]
      ) {
        return this.membersByUserIdByRallyId[rid][uid];
      }

      return null;
    },
    myRole() {
      return this.myMembership
        ? this.myMembership.attributes["role"]
        : "Friend";
    },
    rallyId() {
      return this.rally.id;
    }

  },
  watch: {
    
  },
  async created() {
    this.clearMemberSearchResults({});

    if (this.rally.attributes.editable) {
      await this.fetchMembersByRally({
        rallyId: this.rallyId,
        status: ["Active", "Invited", "Affiliated", "Pending"],
        customPageSize: 20
      });
      // Fetch Requested separately so they aren't lost to pagination
      await this.fetchMembersByRally({
        rallyId: this.rallyId,
        status: ["Requested"],
        customPageSize: 20,
        forcePageOne: true
      });
    } else {
      await this.fetchMembersByRally({
        rallyId: this.rallyId,
        status: ["Active", "Affiliated"],
        customPageSize: 20
      });
    }

    await this.fetchMembersByRally({
      rallyId: this.rallyId,
      fetchMyMemberInfo: true,
      status: undefined,
      customPageSize: 1
    });
  },
  methods: {
    ...mapActions("memberships", [
      "fetchMembersByRally",
      "clearMemberSearchResults",
      "clearMemberState",
      "reinviteMember",
      "resendInvitation"
    ]),
    ...mapActions("rallies", [ "fetchRalliesWithInfo"]),
    reloadPage(){
      location.reload()
    },
    sortedMemberList(mems) {
      if (!mems || !mems.length) return [];
      const statusOrder = { 'Requested': 0, 'Pending': 1 };
      return [...mems].sort((a, b) => {
        const aOrder = statusOrder[a.attributes.status] !== undefined ? statusOrder[a.attributes.status] : 99;
        const bOrder = statusOrder[b.attributes.status] !== undefined ? statusOrder[b.attributes.status] : 99;
        if (aOrder !== bOrder) return aOrder - bOrder;
        return 0;
      });
    },
    filterNonRequestee(mems) {
      return mems.filter(item => item.attributes.status != 'Requested');
    },
    filterPending(mems) {
      if (this.isAdmin && mems?.filter){
        return mems?.filter(item => item.attributes.status === 'Pending');
      } else {
        return []
      }
    },
    filterNonPending(mems) {
      if (mems && mems.filter){
        return mems.filter(item => item.attributes.status != 'Pending');
      } else {
        return []
      }
    },
    filterRequestee(mems) {
      if (mems && mems.filter){
        return mems.filter(item => item.attributes.status === 'Requested');
      } else {
        return []
      }
    },
    filterMembers() {
      this.clearMemberSearchResults({});
      this.clearMemberState({});
      if (this.selectedRally.attributes.editable) {
        this.fetchMembersByRally({
          rallyId: this.rallyId,
          status: ["Active", "Invited", "Affiliated", "Pending"],
          customPageSize: 20
        });
      } else {
        this.fetchMembersByRally({
          rallyId: this.rallyId,
          status: ["Active", "Affiliated"],
          customPageSize: 20
        });
      }
      if (this.rally.attributes.editable) {
        this.fetchMembersByRally({
          rallyId: this.rallyId,
          status: ["Requested"],
          customPageSize: 20
        });
      }
    },
    async refreshMembersByStatus(clearState=true) {
      let status = this.membersFilter
      if (status === 'only_friends') {
        await this.refreshMembers( ['Friend', 'Subscriber'], ["Active"], clearState)
      } else if (status == 'admins') {
        await this.refreshMembers( ['Owner', 'Admin'], ["Active"], clearState)
      } else if (status == 'all_members') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited"], clearState)
      } else if (status == 'all_members_and_declinees') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Active", "Invited", "Declined", "Pending"],clearState)
      } else if (status == 'declinees') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Declined"],clearState)
      } else if (status == 'invitees') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Invited"],clearState)
      } else if (status == 'requestees') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Requested"],clearState)
      } else if (status == 'pending') {
        await this.refreshMembers( ['Owner', 'Admin', 'Friend', 'Subscriber'], ["Pending"],clearState)
      }
      // Fetch Requested members separately for filters where they should appear
      var hideRequested = ['requestees', 'admins', 'declinees', 'pending', 'invitees'];
      if (hideRequested.indexOf(status) === -1 && this.isAdmin) {
        await this.fetchMembersByRally({
          rallyId: this.rallyId,
          status: ["Requested"],
          customPageSize: 20,
          forcePageOne: true
        });
      }
    },
    async refreshMembers(role, status, clearState=true) {
      if (clearState){
        this.clearMemberSearchResults({});
        this.clearMemberState({});
      }
      //we need to query for all status until we get to later pages of data at which time the current members admin flag will be loaded
      await this.fetchMembersByRally({
        rallyId: this.rallyId,
        role: role,
        status: status,
        customPageSize: 20
      });
      //this.$refs.infLoad.stateChanger.reset(); 
    },
    //we have to pass in the status filter for subsequent pages so we get a correct total count...by default the status is filtered anyhow but...
    //there seems to be a bug with the backend total count
    async loadNextPage(){
      if (this.membersFilter){
        //don't clear when we are paginating
        await this.refreshMembersByStatus(false)
      } else {
        await this.fetchMembersByRally({ 
          rallyId: this.rallyId,
          status: this.rally.attributes.editable ? ["Active", "Invited", "Requested", "Affiliated", "Pending"]: ["Active" , "Affiliated"],
          customPageSize: 20
        });
      }
    },
    async infiniteHandler($state) {
      let beforesize = this.members.length
      await this.loadNextPage();
      if (beforesize == this.members.length){
        console.log("complete!!!!" + beforesize + "=>" + this.members.length)
        this.isComplete = true
        $state.complete(); 
      } else {
        console.log("loaded!!!!" + beforesize + "=>" + this.members.length)
        $state.loaded();
      }
      
    },
    log(message) {
      this.$log.debug(message);
    }
  }
};
</script>
